import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AccountService } from '../../../../services/account.service';
import { PageGrid } from '../../../../utils/page-grid';
import { ActivatedRoute, Route } from '@angular/router';
import { FormBuilder, FormControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from '../../../../services/http.service';
import * as moment from 'moment';

@Component({
  selector: 'app-ledger-portfolio',
  templateUrl: './ledger-portfolio.component.html',
  styleUrls: ['./ledger-portfolio.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class LedgerPortfolioComponent implements OnInit {
  portfolioData = null;
  dataInProgress = false;
  toDate = new Date();
  currentUser;
  fundId = new FormControl({ customerCode: '', customerName: '' }, []);
  balanceInfo;
  investerCode;
  portfolioPageGrid: PageGrid;
  defaultPageGridSize = 10;
  calsPortfolioGridInProgress: boolean;
  downloadingReport = false;
  calsPortfolioSortFieldList = [
    {
      id: 1,
      name: 'Portfolio Value - Lowest',
      sortField: 'portfolioValue,asc',
    },
    {
      id: 2,
      name: 'Portfolio Value - Highest',
      sortField: 'portfolioValue,desc',
    },
    {
      id: 3,
      name: 'No. of Shares - Lowest',
      sortField: 'quantity,asc',
    },
    {
      id: 2,
      name: 'No. of Shares - Highest',
      sortField: 'quantity,desc',
    },
  ];
  equityPortfolio: any;

  constructor(
    private cdRef: ChangeDetectorRef,
    private account: AccountService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private http: HttpClient,
    private httpService: HttpService
  ) {}

  async ngOnInit() {
    this.currentUser = await this.account.currentUserAsync();

    this.currentUser.marginTradeDetails.forEach((jontAcc, index) => (jontAcc['index'] = index));
    // console.log(this.currentUser);

    this.activatedRoute.params.subscribe((params) => {
      this.investerCode = params['investorCode'];
      this.fundId.setValue({ customerCode: params['investorCode'], customerName: '' });
      this.loadPageData(params['investorCode']);
    });
    this.fundId.valueChanges.subscribe((val) => {
      if (val) {
        this.loadPageData(val.customerCode);
      }
    });
    this.cdRef.detectChanges();
  }

  async loadPageData(investorCode) {
    let date = new Date();

    try {
      this.dataInProgress = true;
      this.cdRef.detectChanges();

      let toDate = moment(this.toDate).format('YYYY-MM-DD');
      this.portfolioData = await this.account.getMarginTradePortfolio(toDate, investorCode);
      this.loadGridData(this.portfolioData);
      this.dataInProgress = false;
      this.cdRef.detectChanges();
    } catch (e) {
      this.portfolioData = [];
      this.dataInProgress = false;
      console.log(e);
    }
    this.cdRef.detectChanges();
  }

  loadGridData(data) {
    this.calsPortfolioGridInProgress = true;
    this.cdRef.detectChanges();
    this.portfolioPageGrid = new PageGrid(this.fb, 10)
      .setSources(
        async (li) => {
          this.cdRef.detectChanges();
          return { data: data?.portfolio.length || 0 };
        },
        async (li) => {
          let portfolioData = data.portfolio.slice(li.page * li.take, (li.page + 1) * li.take);
          this.cdRef.detectChanges();
          return { data: [...portfolioData] };
        }
      )
      .setFilters({});
    this.calsPortfolioGridInProgress = false;
    this.cdRef.detectChanges();
  }

  get(url: string, data?: any) {
    const token = localStorage['atk'];
    let formattedUrl = this.httpService.baseApiUrl + this.httpService.baseApiPath + url;
    let headers = new HttpHeaders().set('Authorization', token && 'Bearer ' + token);

    return this.http.get(formattedUrl, { headers, responseType: 'blob' }).toPromise();
  }

  async downloadReport(downloadUrl: string) {
    this.downloadingReport = true;
    this.cdRef.detectChanges();
    // let downloadURL = this.httpService.baseApiUrl + this.httpService.baseApiPath + '/live-market-data/download-stock-tracker-data-pdf';
    try {
      let toDate = moment(this.toDate).format('YYYY-MM-DD');
      let data = await this.get(downloadUrl + '?date=' + toDate + '&investorCode=' + this.investerCode);
      this.downloadFile(data, 'Portfolio Summary - ' + moment(new Date()).format('YYYY-MM-DD') + '.pdf');
      this.downloadingReport = false;
      this.cdRef.detectChanges();
    } catch (e) {
      this.downloadingReport = false;
      this.cdRef.detectChanges();
    }
  }

  downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 1);
  };

  rowCallback = (({ dataItem }) => {
    if (dataItem.gainPercentage > 0) {
      return { increased: true };
    }
    if (dataItem.gainPercentage < 0) {
      return { decreased: true };
    }
  }).bind(this);
}
